export const TRANSACTION_STATUS = {
  SUCCESS: "success",
  PENDING: "pending",
  CANCEL: "cancel",
};

export const TRANSACTION = {
  TOPUP: "TOPUP",
  WITHDRAW: "WITHDRAW",
};
